/* eslint-disable react/no-danger */
/* eslint-disable react/no-unknown-property */
import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import List from '@taglivros/oef_componentes/build/components/list'
import Link from '../../../components/Link/Link'
import InformacaoPlano from '../../../components/InformacaoPlano/InformacaoPlano'
import ConteudoWrapper from '../../../components/ConteudoWrapper/ConteudoWrapper'
import BreadcrumbGlobal from '../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import { useGlobal } from '../../../contexts/GlobalContext'
import { useModalidade } from '../../../contexts/ModalidadeContext'
import { URLS, PLANO_ANUAL, PLANO_MENSAL, PLANO_TRIMESTRAL, STATUS_CANCELADO, MODALIDADE_CURADORIA, MODALIDADE_INEDITOS, STATUS_AGUARDANDO_CANCELAMENTO, STATUS_SOLICITOU_CANCELAMENTO, EVENTOS_GA } from '../../../constants'
import { UPGRADE_TITULO, CANCELAMENTO_DESCRICAO, CANCELAMENTO_TITULO, SEGUNDA_ASSINATURA_DESCRICAO, SEGUNDA_ASSINATURA_INEDITOS, SEGUNDA_ASSINATURA_CURADORIA } from './constantsPlano'
import { enviaEventoGA } from '../../../utils/helpers/helpersGA'
import { isEmptyObject, objetoTemPropriedade } from '../../../utils/helpers/helpers'
import blueArrow from '../../../assets/imagens/arrow-blue.svg'
import { getTextoDescontoUpgradePlano } from '../../../utils/helpers/helperPlano'

const Titulo = styled.h1`
  ${StyleGuide.tipografia.titulo1};
  margin: 25px 0 10px 0;

  @media ( max-width: ${StyleGuide.mediaQuery.tablet} ) {
    margin: 25px auto 10px auto;
    max-width: 70%;
  }

  @media ( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    margin: 15px 0 0 0;
    max-width: 100%;
  }
`

const Plano = () => {
  const [ links, setLinks ] = useState( [] )
  const { dadosGlobaisAssociado, modalidadeURL } = useGlobal()
  const [ assinaturaIneditos, setAssinaturaIneditos ] = useState()
  const [ assinaturaCuradoria, setAssinaturaCuradoria ] = useState()
  const [ controlesDaAssinatura, setControlesDaAssinatura ] = useState( {} )
  const [ modalidadeIneditos, setModalidadeIneditos ] = useState()
  const [ modalidadeCuradoria, setModalidadeCuradoria ] = useState()
  const { assinaturaPorModalidade, fetchAssinaturaPorModalidade } = useModalidade()
  const [ modalidadeAssinatura, setModalidadeAssinatura ] = useState()

  useEffect( () => {
    if ( modalidadeURL ) {
      fetchAssinaturaPorModalidade( modalidadeURL )
    }
  }, [ modalidadeURL ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado && objetoTemPropriedade( dadosGlobaisAssociado, 'assinaturas' ) ) {
      const curadoria = dadosGlobaisAssociado.assinaturas.find( assinatura => assinatura.modalidade === MODALIDADE_CURADORIA.visualizacao )
      const ineditos = dadosGlobaisAssociado.assinaturas.find( assinatura => assinatura.modalidade === MODALIDADE_INEDITOS.visualizacao )

      if ( curadoria ) {
        setAssinaturaCuradoria( curadoria )
        setControlesDaAssinatura( curadoria.controles )
      }

      if ( ineditos ) {
        setAssinaturaIneditos( ineditos )
        setControlesDaAssinatura( ineditos.controles )
      }

      const controleModalidades = [
        [ MODALIDADE_CURADORIA.id, setModalidadeCuradoria, curadoria ],
        [ MODALIDADE_INEDITOS.id, setModalidadeIneditos, ineditos ]
      ]

      for ( const [ modalidadeId, modalidadeSetter, assinatura ] of controleModalidades ) {
        const modalidade = dadosGlobaisAssociado.modalidades.find( modalidadeAssinaturaAssociado => modalidadeAssinaturaAssociado.id === modalidadeId )
        if ( modalidade ) {
          modalidadeSetter( modalidade )

          if ( assinatura ) {
            setModalidadeAssinatura( modalidade )
          }
        }
      }
    }
  }, [ dadosGlobaisAssociado, modalidadeURL ] )

  useEffect( () => {
    if ( assinaturaPorModalidade && ( assinaturaIneditos || assinaturaCuradoria ) ) {
      let acoesDisponiveis = []
      const hasUmaAssinatura = assinaturaIneditos || assinaturaCuradoria
      const hasDuasAssinaturas = assinaturaIneditos && assinaturaCuradoria
      const podeFazerUpgradePlano = assinaturaPorModalidade.plano === PLANO_MENSAL.visualizacao || assinaturaPorModalidade.plano === PLANO_TRIMESTRAL.visualizacao
      if ( podeFazerUpgradePlano && assinaturaPorModalidade.status !== STATUS_CANCELADO ) {
        const upgrade = {
          'handleOnClick': () => enviaEventoGA( EVENTOS_GA.UPGRADE.FLUXO, EVENTOS_GA.UPGRADE.ACOES.INIT ),
          'route': `/${modalidadeURL}/${URLS.PLANO}/${URLS.UPGRADE_ENTREGA}`,
          'subtitle': `${getTextoDescontoUpgradePlano( modalidadeURL, assinaturaPorModalidade.plano, PLANO_ANUAL.slug )}`,
          'title': `${UPGRADE_TITULO}`
        }
        acoesDisponiveis = [ ...acoesDisponiveis, upgrade ]
      }
      if ( hasUmaAssinatura && !hasDuasAssinaturas ) {
        const modalidadeSegundaAssinatura = assinaturaCuradoria ? modalidadeIneditos : modalidadeCuradoria

        if (
          !modalidadeSegundaAssinatura.temCobrancaBoletoPendente?.temCobrancaBoletoPendente &&
          !modalidadeSegundaAssinatura.temCobrancaPixPendente?.temCobrancaPixPendente
        ) {
          const segundaAssinatura = {
            'handleOnClick': () => enviaEventoGA(
              EVENTOS_GA.SEGUNDA_ASSINATURA.FLUXO,
              EVENTOS_GA.SEGUNDA_ASSINATURA.ACOES.INIT
            ),
            'route': `/${modalidadeURL}/${URLS.PLANO}/${URLS.SEGUNDA_ASSINATURA_PLANO}`,
            'subtitle': `${SEGUNDA_ASSINATURA_DESCRICAO}`,
            'title': `${
              assinaturaCuradoria
                ? SEGUNDA_ASSINATURA_INEDITOS
                : SEGUNDA_ASSINATURA_CURADORIA
            }`
          }
          acoesDisponiveis = [ ...acoesDisponiveis, segundaAssinatura ]
        }
      }
      if ( assinaturaPorModalidade.status !== STATUS_CANCELADO && assinaturaPorModalidade.status !== STATUS_AGUARDANDO_CANCELAMENTO && assinaturaPorModalidade.status !== STATUS_SOLICITOU_CANCELAMENTO ) {
        const solicitacaoCancelamento = {
          'handleOnClick': () => enviaEventoGA( EVENTOS_GA.CANCELAMENTO.FLUXO, EVENTOS_GA.CANCELAMENTO.ACOES.INIT ),
          'route': `/${modalidadeURL}/${URLS.PLANO}/${URLS.CANCELAR_ASSINATURA_INICIAL}`,
          'subtitle': `${CANCELAMENTO_DESCRICAO}`,
          'title': `${CANCELAMENTO_TITULO}`,
          'testId': 'solicitar-cancelamento'
        }
        acoesDisponiveis = [ ...acoesDisponiveis, solicitacaoCancelamento ]
      }
      if ( !links.length ) {
        setLinks( ( prevState ) => ( [
          ...prevState,
          ...acoesDisponiveis
        ] ) )
      }
    }
  }, [ assinaturaPorModalidade, assinaturaCuradoria, assinaturaIneditos ] )

  return (
    <Fragment>
      <BreadcrumbGlobal
        exactPath="plano"
        nomeAlternativo="plano"
        palavrasExcluidas={ /upgrade/u }
      />

      <Titulo>
        Dados da Assinatura
      </Titulo>

      { !isEmptyObject( assinaturaPorModalidade ) ?
        <ConteudoWrapper>
          {
            modalidadeAssinatura ?
              <InformacaoPlano
                dadosAssinatura={{ ...assinaturaPorModalidade, controlesDaAssinatura }}
                modalidadeAssinatura={ modalidadeAssinatura }
              /> : null
          }

          {
            links && links.length > 0 ?
              <List
                className="listPlano"
                itemPadding={ StyleGuide.isMobile() ? '20px' : '20px 40px' }
                items={ links }
              >
                {
                  links.map( ( link ) => (
                    <li
                      key={ link.route }
                      onClick={ link.handleOnClick }
                      testId={ link.testId }
                    >
                      <Link to={ link.route }>
                        <div>
                          <h3>
                            { link.title }
                          </h3>

                          <span dangerouslySetInnerHTML={{ '__html': link.subtitle }} />

                        </div>

                        <img
                          alt="flecha"
                          src={ blueArrow }
                        />
                      </Link>
                    </li>
                  ) )
                }
              </List> : null
          }
        </ConteudoWrapper>
        : <InlineLoader isCenter />}
    </Fragment>
  )
}

Plano.propTypes = {

}

export default Plano

